var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_353_4458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3229,
    y: 21.3229,
    width: 182.562,
    height: 124.354,
    rx: 14.5521,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 2.64583
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2035 64.9792L35.875 103.327H56.6196L59.1913 97.2124H65.0697L67.6415 103.327H90.4755V98.6601L92.5101 103.327H104.322L106.356 98.5614V103.327H153.845L159.619 97.3712L165.026 103.327L189.417 103.376L172.034 84.26L189.417 64.9792H165.404L159.783 70.8246L154.547 64.9792H102.885L98.4493 74.877L93.909 64.9792H73.2077V69.487L70.9048 64.9792H53.2035ZM124.118 70.4246H151.388L159.729 79.434L168.338 70.4246H176.679L164.006 84.2545L176.679 97.9251H167.96L159.619 88.811L150.966 97.9251H124.118V70.4246ZM130.852 81.1454V76.1222V76.1174H147.868L155.293 84.1507L147.539 92.228H130.852V86.7441H145.729V81.1454H130.852ZM57.2174 70.4246H67.3293L78.8233 96.4281V70.4246H89.9005L98.7782 89.069L106.96 70.4246H117.982V97.9413H111.275L111.221 76.3794L101.443 97.9413H95.4439L85.6117 76.3794V97.9413H71.8148L69.1992 91.7724H55.0679L52.4577 97.9359H45.0655L57.2174 70.4246ZM57.4809 86.0693L62.1366 75.08L66.7869 86.0693H57.4809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_353_4458",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_353_4458",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.94e9b8cd41a109b35206446470bca05b.svg";
export { ForwardRef as ReactComponent };